import { render, staticRenderFns } from "./TestProgressManagement.vue?vue&type=template&id=973c5f1c&scoped=true"
import script from "./TestProgressManagement.vue?vue&type=script&lang=js"
export * from "./TestProgressManagement.vue?vue&type=script&lang=js"
import style0 from "./TestProgressManagement.vue?vue&type=style&index=0&id=973c5f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c5f1c",
  null
  
)

export default component.exports